import { render, staticRenderFns } from "./ContestEnterPopup.vue?vue&type=template&id=36faea83&scoped=true&"
import script from "./ContestEnterPopup.vue?vue&type=script&lang=ts&"
export * from "./ContestEnterPopup.vue?vue&type=script&lang=ts&"
import style0 from "./ContestEnterPopup.vue?vue&type=style&index=0&id=36faea83&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36faea83",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDialog } from 'vuetify/lib/components/VDialog';
installComponents(component, {VDialog})
